import {
    Box,
    CircularProgress,
    createStyles,
    Theme,
    Typography,
    withStyles,
    WithStyles,
} from "@material-ui/core";
import React from "react";
import { commonClasses } from "../styles";
import { colors } from "../theme";

const styles = (theme: Theme) =>
    createStyles({
        ...commonClasses,
        container: {
            position: "relative",
            marginBottom: "-8px",
            lineHeight: 0,
        },
        background: {
            color: colors.red.original,
        },
        foreground: {
            position: "absolute",
            left: -1,
            top: -1,
            color: "#fbfbfd",
        },
        labelContainer: {
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        hide: {
            opacity: 0,
        },
        show: {
            opacity: 1,
        },
        "blink-0": {
            animation: "$blinker0 1s linear",
        },
        "blink-1": {
            animation: "$blinker1 1s linear",
        },
        "@keyframes blinker0": {
            "0%": {
                opacity: 0,
            },
            "30%": {
                opacity: 1,
            },
        },
        "@keyframes blinker1": {
            "0%": {
                opacity: 0,
            },
            "30%": {
                opacity: 1,
            },
        },
        protrusion: {
            position: "absolute",
            backgroundColor: "#fbfbfd",
            left: "-10%",
            bottom: "-8px",
            width: "120%",
            height: "100%",
            borderRadius: "50%",
        },
    });

type Props = WithStyles<typeof styles> & {
    maxValue: number;
    remainingTime?: number;
    isVideo?: boolean;
};

type State = {
    toggleToRender?: boolean;
};

class Component extends React.Component<Props, State> {
    labelRef: React.RefObject<HTMLElement>;
    remainingTime?: number;
    constructor(props: Props) {
        super(props);
        this.state = {};
        this.labelRef = React.createRef();
    }

    componentDidUpdate = (prevProps: Props) => {
        const { remainingTime, classes } = this.props;
        const { remainingTime: prevRemainingTime } = prevProps;
        const { toggleToRender } = this.state;
        if (remainingTime !== prevRemainingTime) {
            this.labelRef.current?.classList.remove(
                classes[toggleToRender ? "blink-0" : "blink-1"]
            );
            this.labelRef.current?.classList.add(classes[toggleToRender ? "blink-1" : "blink-0"]);
            this.setState((state) => ({ toggleToRender: !state.toggleToRender }));
        }
    };

    render = () => {
        const { classes, remainingTime, maxValue, isVideo } = this.props;
        const currentValue = !!remainingTime && remainingTime >= 0 ? remainingTime : maxValue;
        return (
            <Box className={classes.container}>
                {!isVideo && <Box className={classes.protrusion} />}
                <CircularProgress
                    className={classes.background}
                    variant="determinate"
                    thickness={5}
                    value={100}
                />
                <CircularProgress
                    className={classes.foreground}
                    variant="determinate"
                    size={42}
                    thickness={7}
                    value={(1 - currentValue / maxValue) * 100}
                />
                <Box className={classes.labelContainer}>
                    <Typography variant="subtitle1" ref={this.labelRef}>
                        {currentValue}
                    </Typography>
                </Box>
            </Box>
        );
    };
}

const Timer = withStyles(styles)(Component);

export default Timer;
